import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { MsService } from './ms.service';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthServiceApp {
  public isAuthenticated$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(!!localStorage.getItem('accessToken'));

  constructor(private msService: MsService) {}

  async requestOtp(email: string): Promise<{ ok: boolean; expiresAt: number }> {
    const res: any = await firstValueFrom(this.msService.post('auth-service/login', { email }));
    return { ok: !!res?.ok, expiresAt: res?.expiresAt };
  }

  async verifyOtp(email: string, nonce: string, authProviderId?: string): Promise<{ ok: boolean }> {
    const res: any = await firstValueFrom(this.msService.post('auth-service/otp-verify', { email, nonce, authProviderId }));
    if (res?.ok && res?.accessToken) {
      localStorage.setItem('accessToken', res.accessToken);
      if (res?.refreshToken) localStorage.setItem('refreshToken', res.refreshToken);
      if (res?.user) localStorage.setItem('user', JSON.stringify(res.user));
      this.isAuthenticated$.next(true);
      return { ok: true };
    }
    return { ok: false };
  }

  getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken') || '';
    return new HttpHeaders({ Authorization: `Bearer ${token}` });
  }

  async verifyCredential(idToken: string): Promise<{ ok: boolean; accessToken?: string; user?: any }> {
    try {
      const res: any = await firstValueFrom(this.msService.post('auth-service/verify-credential', { idToken, provider: 'google' }));
      // Expecting backend to respond with { ok, sub, email, token?, user? }
      if (res?.ok && res?.accessToken) {
        localStorage.setItem('accessToken', res.accessToken);
        localStorage.setItem('refreshToken', res.refreshToken);
        if (res?.user) localStorage.setItem('user', JSON.stringify(res.user));
        this.isAuthenticated$.next(true);
      }
      return {
        ok: !!res?.ok,
        user: res?.user,
      };
    } catch (e) {
      return { ok: false };
    }
  }

  private decodeJwt(token: string): any {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    try {
      return JSON.parse(json);
    } catch {
      return null;
    }
  }

  logout() {
    localStorage.clear();
    this.isAuthenticated$.next(false);
  }
}
